export default "__VITE_ASSET__0de42ac8__"